// extracted by css-extract-rspack-plugin
export default {"dark":"app__dark___fQD9C","mainContainer":"app__mainContainer___LexBJ","main":"app__main___rLV1F","content":"app__content___r3Yju"};